import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { LocalServerDto2 } from '../../dto/LocalServerDto2';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteLocalServer2 = async (dto: LocalServerDto2) => {
  const params: IApiParams = {
    url: '/localserver2/deleteLocalServer2.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
